import startSearchWithRefiners from './searchRefiners/startSearchWithRefiners';
import { lazyIsSearchBoxEmpty, SearchScenarioId } from 'owa-search';
import { logUsage } from 'owa-analytics';
import { onRefinerChanged, RefinerType } from 'owa-calendar-search-store';
import { orchestrator } from 'satcheljs';

export default orchestrator(onRefinerChanged, async actionMessage => {
    const refinerType: RefinerType = actionMessage.refinerType;

    // Log CTQ to indicate which refiner was changed.
    const isSearchBoxEmpty = await lazyIsSearchBoxEmpty.import();
    logUsage(
        'Search_RefinerClicked',
        customData(isSearchBoxEmpty(SearchScenarioId.Calendar), refinerType)
    );

    // Start search.
    startSearchWithRefiners();
});

function customData(
    isSearchBoxEmpty: boolean,
    refinerType: RefinerType
): [boolean, boolean, boolean, boolean, boolean] {
    /**
     * The RefinerType passed in indicates which of the refiners
     * (calendarFolders, includeAttachments, fromDate, toDate) was changed. The
     * customData array is defined like this: [isSearchBoxEmpty,
     * calendarFolder, includeAttachmentsChanged, fromDateChanged, toDateChanged].
     */
    switch (refinerType) {
        case RefinerType.calendarScopes:
            return [isSearchBoxEmpty, true, false, false, false];
        case RefinerType.includeAttachments:
            return [isSearchBoxEmpty, false, true, false, false];
        case RefinerType.fromDate:
            return [isSearchBoxEmpty, false, false, true, false];
        case RefinerType.toDate:
            return [isSearchBoxEmpty, false, false, false, true];
    }
}
